<template>
    <div class="container-fluid">
        <div class="row">
        <div class=" col-auto d-sm-block d-none sidebar-bg-color " >
              <div class=" text-white min-vh-100">
                <div class="row justify-content-center mt-2">
                  <div :class="ShowBar?'col-md-6':'col-12'">
                    <img src="https://ugcollege.ge/public//assets/images/logo-white.svg" alt="">
                  </div>

                </div>
                <div class=" d-flex text-white mt-3">
                 <span><img src="../assets/images/download.jpg" class="img-fluid rounded-circle mt-2" alt=""></span>
                 <span class="d-md-block d-none" v-if="ShowBar"> <p class="ms-2 mt-4">{{this.$store.state.user.fname}} {{ this.$store.state.user.lname }}</p></span>
                </div>

                  <router-link to="/" class="text-decoration-none text-white">
                      <div class="row g-0  mt-2 p-3"> 
                          <div class="col-12 col-md-1  text-center "><i class='bx bx-home-alt-2'></i></div> 
                          <div class=" col-md-11 d-md-block d-none  px-2" v-if="ShowBar">მთავარი</div> 
                    </div>
                     </router-link>


                        <router-link to="/table" class="text-decoration-none text-white">
                     <div class="row g-0  mt-2 p-3"> 
                          <div class="col-12 col-md-1  text-center"><i class='bx bx-table'></i></div> 
                          <div class=" col-md-11 d-md-block d-none  px-2" v-if="ShowBar">ჩემი ცხრილი</div> 
                    </div>
                     </router-link>

                         <router-link to="/estimates" class="text-decoration-none text-white">
                    <div class="row g-0  mt-2 p-3"> 
                          <div class="col-12 col-md-1  text-center "><i class='bx bx-edit-alt'></i></div> 
                          <div class=" col-md-11 d-md-block d-none  px-2" v-if="ShowBar">შეფასებები</div> 
                    </div>
                         </router-link>

                          <router-link to="/statement" class="text-decoration-none text-white">
                    <div class="row g-0  mt-2 p-3"> 
                          <div class="col-12 col-md-1  text-center "><i class='bx bx-folder'></i></div> 
                          <div class=" col-md-11 d-md-block d-none  px-2" v-if="ShowBar">განცხადებები</div> 
                    </div>
                          </router-link>

                         <router-link to="/library" class="text-decoration-none text-white">
                     <div class="row g-0  mt-2 p-3"> 
                          <div class="col-12 col-md-1  text-center"><i class='bx bx-book'></i></div> 
                          <div class=" col-md-11 d-md-block d-none  px-2" v-if="ShowBar">ბიბლიოთეკა</div> 
                    </div>
                         </router-link>

                    <!-- <router-link to="/messages" class="text-decoration-none text-white">
                     <div class="row g-0  mt-2 p-3"> 
                          <div class="col-12 col-md-1 text-center"><i class='bx bx-message-rounded-check '></i></div> 
                          <div class=" col-md-11 d-md-block d-none  px-2" v-if="ShowBar">შეტყობინებები</div> 
                    </div>
                    </router-link> -->

               
           </div>

          </div>

      <div class="col  h-100px h-100px-bg">


            <div class="row">
                  <div class="col-1">
                        <i class='bx bx-menu cursor-pointer fs-3 mt-3 text-white icon-menu' @click='ShowleftHide()' v-if="menuburger"></i>
                  </div>
                  <div class="col-11 mt-2">

                        <button type="button"   @click="logOut()" class="btn btn-outline-success text-white d-block ms-auto "><i class='bx bxs-log-in-circle  fs-3 mt-1'></i></button>
                  </div>
            </div>
          

              <div class="row ">

                  <div class="col-12 h-100vh mt-3">

                    <div class="row myRow">
                      <div class="col-2">
                            <router-link to="/" class="text-decoration-none text-white">
                      <div class="row g-0  mt-2"> 
                          <div class="col-12 col-md-1  text-center "><i class='bx bx-home-alt-2'></i></div> 
                          <div class=" col-md-11 d-md-block d-none  px-2" v-if="ShowBar">მთავარი</div> 
                    </div>
                     </router-link>
                      </div>
                      <div class="col-2">
                           <router-link to="/table" class="text-decoration-none text-white">
                     <div class="row g-0  mt-2 "> 
                          <div class="col-12 col-md-1  text-center"><i class='bx bx-table'></i></div> 
                          <div class=" col-md-11 d-md-block d-none  px-2" v-if="ShowBar">ჩემი ცხრილი</div> 
                    </div>
                     </router-link>
                      </div>
                      <div class="col-2">
                          <router-link to="/estimates" class="text-decoration-none text-white">
                    <div class="row g-0  mt-2 "> 
                          <div class="col-12 col-md-1  text-center "><i class='bx bx-edit-alt'></i></div> 
                          <div class=" col-md-11 d-md-block d-none  px-2" v-if="ShowBar">შეფასებები</div> 
                    </div>
                         </router-link>
                      </div>
                      <div class="col-2">
                           <router-link to="/statement" class="text-decoration-none text-white">
                    <div class="row g-0  mt-2"> 
                          <div class="col-12 col-md-1  text-center "><i class='bx bx-folder'></i></div> 
                          <div class=" col-md-11 d-md-block d-none  px-2" v-if="ShowBar">განცხადებები</div> 
                    </div>
                          </router-link>
                      </div>
                      <div class="col-2">
                        
                         <router-link to="/library" class="text-decoration-none text-white">
                     <div class="row g-0  mt-2"> 
                          <div class="col-12 col-md-1  text-center"><i class='bx bx-book'></i></div> 
                          <div class=" col-md-11 d-md-block d-none  px-2" v-if="ShowBar">ბიბლიოთეკა</div> 
                    </div>
                         </router-link>
                      </div>
                      <div class="col-2">
                      
                    <!-- <router-link to="/messages" class="text-decoration-none text-white">
                     <div class="row g-0  mt-2"> 
                          <div class="col-12 col-md-1 text-center"><i class='bx bx-message-rounded-check '></i></div> 
                          <div class=" col-md-11 d-md-block d-none  px-2" v-if="ShowBar">შეტყობინებები</div> 
                    </div>
                    </router-link> -->
                      </div>

                    </div>

                  </div>
          <router-view/>
            


              </div>

          </div>

        </div>

    </div>
</template>

 <script>
import HttpRequests from '../httpRequests/httpRequests';
const httpRequests = new HttpRequests()
export default{
 data() {
   return{
     ShowBar:true,
     width:'',
     menuburger:true

   } 
  },
  created(){
    window.addEventListener('resize',()=>{
          this.width=document.documentElement.clientWidth
          if(this.width<=704){
              this.ShowBar=false
              this.menuburger=false
          }else{
              this.ShowBar=true
              this.menuburger=true

          }
          

    })

  },
methods:{
    ShowleftHide(){
     
      this.ShowBar=!this.ShowBar 
    },
    logOut(){

httpRequests.logOut().then(()=>{
      localStorage.removeItem('token')
      window.location.href='/'
})

}
  

}

}
</script>


